import { autoAcceptService } from 'features/settings-page/auto-accept';
import { useEffect, useState } from 'react';

export function useOrdersKanbanPage() {
  const isAutoAccepted = autoAcceptService.isEnabled();
  const [hasAutoAccept, setHasAutoAccept] = useState<boolean>(isAutoAccepted);
  const [totalColumns, setTotalColumns] = useState<number>(
    isAutoAccepted ? 2 : 3,
  );

  useEffect(() => {
    //TODO: move sync here
    const timer = setTimeout(() => {
      const result = autoAcceptService.isEnabled();
      setHasAutoAccept(result);
      setTotalColumns(result ? 2 : 3);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return {
    totalColumns,
    hasAutoAccept,
  };
}
